module.exports = __webpack_public_path__ + "img/corsair21.3fc6ad07.png";